import { Suspense, lazy } from 'react';

const LazyReactQueryDevtools = lazy<
	React.ComponentType<{
		initialIsOpen?: boolean;
		buttonPosition?:
			| 'top-left'
			| 'top-right'
			| 'bottom-left'
			| 'bottom-right';
		position?: 'top' | 'bottom' | 'left' | 'right';
	}>
>(() =>
	import('@tanstack/react-query-devtools').then(module => ({
		default: module.ReactQueryDevtools,
	}))
);

export const ReactQueryDevtools = () => {
	if (import.meta.env.DEV) {
		return (
			<Suspense fallback={null}>
				<LazyReactQueryDevtools
					initialIsOpen={false}
					buttonPosition='bottom-right'
					position='bottom'
				/>
			</Suspense>
		);
	}

	return null;
};
